import { z } from 'zod';
import { domainNameSchema } from './sites.js';

/** How many names one purchase may consider, and how many it may buy (ADR-0039). */
export const PURCHASE_LIMITS = { candidates: 50, buy: 20 } as const;

/**
 * Buying domains, first step: the names to consider and how many of them to
 * buy. 2d2s checks which are free and shortlists up to that many; nothing is
 * paid for until the shortlist is confirmed.
 */
export const startPurchaseSchema = z
  .object({
    candidates: z.array(domainNameSchema).min(1).max(PURCHASE_LIMITS.candidates),
    buy: z.number().int().min(1).max(PURCHASE_LIMITS.buy),
    years: z.number().int().min(1).max(10).default(1),
    autoRenew: z.boolean().default(true),
    privacy: z.boolean().default(true),
  })
  .strict()
  .refine((value) => new Set(value.candidates).size === value.candidates.length, { message: 'Names must be distinct', path: ['candidates'] })
  .refine((value) => value.buy <= value.candidates.length, { message: 'Cannot buy more names than were given', path: ['buy'] });
export type StartPurchaseInput = z.infer<typeof startPurchaseSchema>;
export type StartPurchaseRequest = z.input<typeof startPurchaseSchema>;

/** Buying domains, second step: which of the free names to pay for. */
export const confirmPurchaseSchema = z
  .object({ itemIds: z.array(z.string().regex(/^[A-Za-z0-9_-]{6,64}$/)).min(1).max(PURCHASE_LIMITS.buy) })
  .strict();
export type ConfirmPurchaseRequest = z.input<typeof confirmPurchaseSchema>;
